import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from 'react/components/common/Tooltip/Tooltip';
import { columnClass, renderCellContent } from '../utils';

const TableRow = ({
  row,
  rowIndex,
  visibleColumns,
  selectedRow,
  disabledIds,
  emphasisedIds,
  tableTitle,
  handleRowClick,
  searchPosition,
  crud,
  crudTemplateBody,
  onEdit,
  onDelete,
}) => (
  <div
    key={row.id || rowIndex}
    className={classNames('row', {
      selected: selectedRow && selectedRow.id === row.id,
      disabled: row.disabled || disabledIds[row.id + tableTitle],
      emphasised: row.emphasised || emphasisedIds[row.id + tableTitle],
      open: row.open,
      highlighted: row.highlighted,
    })}
    onClick={() => handleRowClick(row)}
  >
    {visibleColumns.map((column, colIndex) => (
      <div key={column.id} className={classNames('column', columnClass(column), `flex${column.flex || '1'}`)}>
        <Tooltip
          content={
            column.ellipsis && !column.template ? (column.displayValue ? row[column.displayValue] : row[column.id]) : ''
          }
          options={{ popperOptions: { modifiers: { flip: { enabled: false } } } }}
        >
          <span>{renderCellContent(row, column)}</span>
        </Tooltip>

        {row.highlighted && colIndex === (searchPosition || 0) && (
          <span className="highlighted-mark" title={row.highlightMarkTooltip}></span>
        )}
      </div>
    ))}

    {crud && (
      <div className="column crud">
        {crudTemplateBody ? (
          <span dangerouslySetInnerHTML={{ __html: crudTemplateBody }} />
        ) : (
          <span>
            <span
              title="edit"
              onClick={(e) => {
                e.stopPropagation();
                onEdit && onEdit(row);
              }}
            >
              <i className="icon-svg icon-edit_icon"></i>
            </span>
            &nbsp; &nbsp;
            <span
              title="delete"
              onClick={(e) => {
                e.stopPropagation();
                onDelete && onDelete(row);
              }}
            >
              <i className="icon-svg icon-trash"></i>
            </span>
          </span>
        )}
      </div>
    )}

    <div className="column scroll-td"></div>
  </div>
);

TableRow.propTypes = {
  row: PropTypes.object.isRequired,
  rowIndex: PropTypes.number.isRequired,
  visibleColumns: PropTypes.array.isRequired,
  selectedRow: PropTypes.object,
  disabledIds: PropTypes.object,
  emphasisedIds: PropTypes.object,
  tableTitle: PropTypes.string,
  handleRowClick: PropTypes.func.isRequired,
  searchPosition: PropTypes.number,
  crud: PropTypes.bool,
  crudTemplateBody: PropTypes.string,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

export default TableRow;
